export const PROJECT = 'Hey.D';

export const STORAGE = {
  AUTH: {
    REDIRECT_AFTER_LOGIN: 'redirect_login',
  },
} as const;
